// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3cE2H","info":"UpdateTermsInfo_info__19Uh8"};